import { ChevronDown, ChevronUp } from 'lucide-react'
import React, { useState } from 'react'

const Faq = () => {
    const [openFaq, setOpenFaq] = useState<number | null>(null);


    const scrollToSection = (sectionId: string) => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    };

    const toggleFaq = (index: number) => {
        setOpenFaq(openFaq === index ? null : index);
    };
    const faqs = [
        {
            question: "Is my data secure with the Smart Diary App?",
            answer: "Yes, we prioritize your privacy and data security. All your entries are encrypted and stored securely."
        },
        {
            question: "Is the app available for both Android and iOS?",
            answer: "Currently, Smart Dairy is available on the Google Play Store for Android devices. iOS version is coming soon!"
        },
        {
            question: "Can I try the app before purchasing?",
            answer: "Yes! We offer a 7-day free trial so you can experience all the features and see how Smart Dairy can benefit your dairy business."
        },
        {
            question: "What kind of support do you provide?",
            answer: "We provide 24/7 customer support, comprehensive documentation, video tutorials, and dedicated account managers for enterprise customers."
        },
        {
            question: "What features are included in the Smart Diary App?",
            answer: "The app includes customizable entries, reminders, mood tracking, and more to help you stay organized and reflect on your daily experiences."
        },
        {
            question: "How will I receive my activation code?",
            answer: "After a successful payment, your activation code will be sent to the email or mobile number you provided during checkout."
        }
    ];
    return (
        <section id="faq" className="py-20 bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-[#002047] mb-4">
                        Frequently Asked Questions
                    </h2>
                    <p className="text-xl text-gray-600">
                        Find answers to common questions about Smart Dairy
                    </p>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-gray-50 rounded-xl overflow-hidden">
                            <button
                                onClick={() => toggleFaq(index)}
                                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors"
                            >
                                <h3 className="text-lg font-semibold text-[#002047]">{faq.question}</h3>
                                {openFaq === index ?
                                    <ChevronUp className="h-5 w-5 text-[#002047]" /> :
                                    <ChevronDown className="h-5 w-5 text-[#002047]" />
                                }
                            </button>
                            {openFaq === index && (
                                <div className="px-8 pb-6">
                                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <p className="text-gray-600 mb-4">Still have questions?</p>
                    <button
                        onClick={() => scrollToSection('contact')}
                        className="bg-[#002047] text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
                    >
                        Contact Our Team
                    </button>
                </div>
            </div>
        </section>
    )
}

export default Faq
